import React from 'react';
import { FormattedMessage } from 'react-intl';

import { CheckboxInput } from '../checkbox-input/checkbox-input.component';
import { usePredefinedDateRange } from './predefined-date-range.controller';
import { PredefinedDateRangePreset } from './predefined-date-range.utils';

export interface PredefinedDateRangeProps {
    onChange: (start: string, end: string) => void;
}

export const PredefinedDateRange = (props: PredefinedDateRangeProps) => {
    const viewProps = usePredefinedDateRange();

    const onToggle = (preset: PredefinedDateRangePreset, enabled: boolean) => {
        const range = viewProps.selectPreset(preset, enabled);
        if (range) {
            props.onChange(range.start, range.end);
        }
    };

    return (
        <>
            <label className='mt-2'>
                <FormattedMessage
                    id='certificate-predefined-date.label'
                    description='Label above week/month/year date range preset checkboxes'
                    defaultMessage='Predefined'
                />
            </label>
            <div className='flex flex-wrap gap-2'>
                <CheckboxInput
                    label={
                        <FormattedMessage
                            id='certificate-predefined-date.week'
                            description='Checkbox to set a date range of one week from today'
                            defaultMessage='Week'
                        />
                    }
                    id='week'
                    submitted={false}
                    value={viewProps.predefined === 'week'}
                    onChange={(enabled) => onToggle('week', enabled)}
                />
                <CheckboxInput
                    label={
                        <FormattedMessage
                            id='certificate-predefined-date.month'
                            description='Checkbox to set a date range of one month from today'
                            defaultMessage='Month'
                        />
                    }
                    id='month'
                    submitted={false}
                    value={viewProps.predefined === 'month'}
                    onChange={(enabled) => onToggle('month', enabled)}
                />
                <CheckboxInput
                    label={
                        <FormattedMessage
                            id='certificate-predefined-date.year'
                            description='Checkbox to set a date range of one year from today'
                            defaultMessage='Year'
                        />
                    }
                    id='year'
                    submitted={false}
                    value={viewProps.predefined === 'year'}
                    onChange={(enabled) => onToggle('year', enabled)}
                />
            </div>
        </>
    );
};
